module.exports = __webpack_public_path__ + "img/empty.4400d718.svg";